import React from "react";
import styles from "./SectionForm.module.scss";
import FormFeedback from "../Form/FormFeedback";

const SectionForm: React.FC = () => {
    return (
        <div className={styles.sectionForm}>
            <FormFeedback className="formFeedback"/>
        </div>
    )
}

export default SectionForm;